/**
 * Vehicle.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  // tableName: 'vehiculos',

  display: ['economicNumber', 'make', 'model', 'year','plateUs', 'plateMx', 'active'],

  attributes: {

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    economicNumber: {
      type: 'string',
      required: true,
      // columnName: 'numero_economico'
    },

    make: {
      type: 'string',
      allowNull: true,
      // columnName: 'marca'
    },

    model: {
      type: 'string',
      allowNull: true,
      // columnName: 'modelo'
    },

    year: {
      type: 'number',
      allowNull: true,
      // columnName: 'año'
    },

    purchasedAt: {
      type: 'ref',
      columnType: 'date',
      // columnName: 'fecha_compra'
    },

    pedimento: {
      type: 'boolean',
      defaultsTo: true
    },

    color: {
      type: 'string',
      allowNull: true
    },

    vin: {
      type: 'string',
      allowNull: true
    },

    plateMx: {
      type: 'string',
      allowNull: true,
      // columnName: 'placa_mx'
    },

    plateUsa: {
      type: 'string',
      allowNull: true,
      // columnName: 'placa_usa'
    },

    scac: {
      type: 'string',
      allowNull: true
    },

    caat: {
      type: 'string',
      allowNull: true
    },

    comments: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
      // columnName: 'comentarios'
    },

    insurancePolicy: {
      type: 'string',
      allowNull: true,
    },

    grossWeight: {
      type: 'string',
      allowNull: true,
    },

    gpsSerialNumber: {
      type: 'string',
      allowNull: true,
    },

    active: {
      type: 'boolean',
      allowNull: true,
    },

    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    supplier: {
      model: 'supplier',
      // columnName: 'proveedor_id'
    },

    type: {
      model: 'vehicletype',
      required: true,
      // columnName: 'tipo_vehiculo_id'
    },

    fuel: {
      model: 'fuel',
      // columnName: 'tipo_combustible_id'
    },

    dispatches: {
      collection: 'dispatch',
      via: 'vehicle'
    }

  },

}




// WEBPACK FOOTER //
// ./src/models/Vehicle.js